<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <div
        class="page-title-box d-flex align-items-center justify-content-between"
      >
        <app-rp-breadcrumb
          [breadcrumbItems]="breadCrumbItems"
        ></app-rp-breadcrumb>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-lg-12">
        <div class="card">
        <div class="card-body">
                  <ng-template #template let-anchor>
                    <span>{{ anchor.nativeElement.innerText }}</span>
                  </ng-template>
                  <div
                    kendoTooltip
                    showOn="none"
                    [tooltipTemplate]="template"
                    filter=".k-grid td"
                    (mouseover)="showTooltip($event)"
                  >
                    <kendo-grid
                      [data]="evReadingsGridData"
                      [pageSize]="pageSize"
                      [skip]="skip"
                      [sortable]="true"
                      [selectable]="selectableSettings"
                      [pageable]="{
                        buttonCount: buttonCount,
                        info: info,
                        type: type,
                        pageSizes: pageSizes,
                        previousNext: previousNext,
                      }"
                      [reorderable]="true"
                      filterable="menu"
                      [filter]="state.filter"
                      [sort]="sort"
                      [columnMenu]="{ filter: true }"
                      [resizable]="true"
                      kendoGridSelectBy="id"
                      scrollable="scrollable"
                      (filterChange)="onFilterChange($event)"
                      (pageChange)="pageChange($event)"
                      (selectionChange)="selectionChanged($event)"
                      (sortChange)="onSortChange($event)"
                    >
                      <ng-template kendoGridToolbarTemplate>
                        <div>
                          <kendo-textbox
                            [style.width.px]="250"
                            [(ngModel)]="evReadingsSearchValue"
                            [clearButton]="true"
                            (valueChange)="clearSearchValueChange($event)"
                            (keyup.enter)="onSearch()"
                            placeholder="Search in all columns..."
                          >
                          </kendo-textbox>

                          <button
                            class="btn btn-primary btn-md border-left-none"
                            (click)="onFilter($event)"
                          >
                            <i class="fa fa-search"></i>
                          </button>
                        </div>
                        <kendo-grid-spacer></kendo-grid-spacer>
                        <button
                          kendoGridExcelCommand
                          class="btn btn-light"
                          (click)="onExport('Excel')"
                        >
                          <span class="fas fa-file-excel"></span> &nbsp; Export
                          to Excel
                        </button>
                      </ng-template>

                      <kendo-grid-checkbox-column
                        [columnMenu]="false"
                        [showSelectAll]="true"
                        [width]="40"
                        class="no-tooltip"
                      ></kendo-grid-checkbox-column>

                   
                
                      <kendo-grid-column
                        field="deviceSRNO"
                        title="Device Sr No"
                        [width]="100"
                        [sortable]="false"
                      >
                        <ng-template
                          kendoGridFilterMenuTemplate
                          let-filter
                          let-column="column"
                          let-filterService="filterService"
                        >
                          <kendo-grid-string-filter-menu
                            [column]="column"
                            [filter]="filter"
                            [filterService]="filterService"
                            [extra]="false"
                            [operator]="'eq'"
                          >
                            <kendo-filter-eq-operator></kendo-filter-eq-operator>
                          </kendo-grid-string-filter-menu>
                        </ng-template>
                      </kendo-grid-column>
                      <kendo-grid-column
                        field="macAddress"
                        title="Mac Address"
                        [width]="100"
                        [sortable]="false"
                      >
                        <ng-template
                          kendoGridFilterMenuTemplate
                          let-filter
                          let-column="column"
                          let-filterService="filterService"
                        >
                          <kendo-grid-string-filter-menu
                            [column]="column"
                            [filter]="filter"
                            [filterService]="filterService"
                            [extra]="false"
                            [operator]="'eq'"
                          >
                            <kendo-filter-eq-operator></kendo-filter-eq-operator>
                          </kendo-grid-string-filter-menu>
                        </ng-template>
                      </kendo-grid-column>
                      <kendo-grid-column
                        field="startDate"
                        title="Start Date"
                        filter="date"
                        [width]="100"
                      >
                        <ng-template kendoGridCellTemplate let-dataItem>
                          {{
                            dataItem.startDate && dataItem.startDate !== "-"
                              ? (dataItem.startDate
                                | date: "dd MMM yyyy hh:mm a")
                              : "-"
                          }}
                        </ng-template>
                      </kendo-grid-column>
                      <kendo-grid-column
                        field="endDate"
                        title="End Date"
                        filter="date"
                        [width]="100"
                      >
                        <ng-template kendoGridCellTemplate let-dataItem>
                          {{
                            dataItem.endDate && dataItem.endDate !== "-"
                              ? (dataItem.endDate
                                | date: "dd MMM yyyy hh:mm a")
                              : "-"
                          }}
                        </ng-template>
                      </kendo-grid-column>
                    
                      <kendo-grid-column
                        field="unitRate"
                        title="Unit Rate (₹)"
                        [width]="80"
                      ></kendo-grid-column>
                      <kendo-grid-column
                        field="amount"
                        title="Amount (₹)"
                        [width]="100"
                      ></kendo-grid-column>
                      <kendo-grid-column
                        field="noOfUnits"
                        title="No. Of Units (KWh)"
                        [width]="100"
                      ></kendo-grid-column>
                      <kendo-grid-column
                        field="projectName"
                        title="Project Name"
                        [width]="120"
                      ></kendo-grid-column>
                      <kendo-grid-command-column
                        [columnMenu]="false"
                        [width]="80"
                        title="View Details"
                      >
                        <ng-template kendoGridCellTemplate let-dataItem>
                          <button
                            class="btn btn-primary btn-sm m-lg-auto"
                            kendoTooltip
                            title="View EV Reading Details"
                            (click)="navigateToViewReadings(dataItem, 'EV Reading Details')"
                          >
                            <i class="fas fa-info-circle"></i>
                          </button>
                        </ng-template>
                      </kendo-grid-command-column>
                   

                      <div
                        style="
                          position: absolute;
                          top: 0;
                          left: -10000px;
                          width: 500px;
                        "
                      >
                        <kendo-grid
                          [kendoGridBinding]="
                            selectedEvReadings.length > 0
                              ? selectedEvReadings
                              : evReadingsGridData.data
                          "
                          #exportEvReadings
                        >
        
                          <kendo-grid-column
                            field="deviceSRNO"
                            title="Device Sr No"
                          ></kendo-grid-column>
                          <kendo-grid-column
                            field="macAddress"
                            title="Mac Address"
                          ></kendo-grid-column>
                          <kendo-grid-column
                            field="startDate"
                            title="Start Date"
                          >
                            <ng-template kendoGridCellTemplate let-dataItem>
                              {{
                                dataItem.startDate && dataItem.startDate !== "-"
                                  ? (dataItem.startDate
                                    | date: "dd MMM yyyy hh:mm a")
                                  : "-"
                              }}
                            </ng-template>
                          </kendo-grid-column>
                          <kendo-grid-column
                            field="endDate"
                            title="End Date"
                          >
                            <ng-template kendoGridCellTemplate let-dataItem>
                              {{
                                dataItem.endDate && dataItem.endDate !== "-"
                                  ? (dataItem.endDate
                                    | date: "dd MMM yyyy hh:mm a")
                                  : "-"
                              }}
                            </ng-template>
                          </kendo-grid-column>
                        
                          <kendo-grid-column
                            field="unitRate"
                            title="Unit Rate (₹)"
                          ></kendo-grid-column>
                          <kendo-grid-column
                            field="amount"
                            title="Amount (₹)"
                          ></kendo-grid-column>
                          <kendo-grid-column
                            field="noOfUnits"
                            title="No. Of Units (kWh)"
                          ></kendo-grid-column>
                          <kendo-grid-column
                            field="projectName"
                            title="Project Name"
                          ></kendo-grid-column>
                       
                          <kendo-grid-excel
                            fileName="EvReadings.xlsx"
                          ></kendo-grid-excel>
                        </kendo-grid>
                      </div>
                    </kendo-grid>
                  </div>
        </div>
      </div>
    </div>
  </div>
</div>
